import { IEPS, IContactSchema } from 'interfaces/EPS';
import { IAlertHandlerState } from 'modules/alertHandler/interfaces';
import { normalizeAndRemoveFields } from 'utils/files';

export const getParsedEps = (
  eps: IEPS,
  addfieldsToRemove: Array<string> = [],
): IEPS => {
  let parsedEPS = Object.assign({}, eps);

  parsedEPS = normalizeAndRemoveFields(parsedEPS, [
    'id',
    'history',
    '_id',
    'createdAt',
    'updatedAt',
    ...addfieldsToRemove,
  ]);
  parsedEPS.contact = parsedEPS.contact.map((contact: IContactSchema) =>
    normalizeAndRemoveFields(Object.assign({}, contact), ['id']),
  );
  return parsedEPS;
};

export const parseResponseEps = (rawEps: IEPS): IEPS => {
  return Object.assign(rawEps, {
    id: rawEps._id,
    contact: rawEps.contact.map((c, id) => ({
      ...c,
      id: id.toString(),
    })),
    EPSServicesCategory: rawEps.EPSServicesCategory.map((c) => c._id),
    EPSServicesType: rawEps.EPSServicesType.map((c) => c._id),
  });
};

const errorsMessageAtCreate = {
  email: {
    title: 'Verificar o campo "Email de atendimento".',
    content:
      'O email de atendimento já foi cadastrado em outra EPS, favor alterar.',
  },
  default: {
    title: 'Erro!',
    content: 'Ocorreu algum erro durante a criação da EPS.',
  },
} as { [key: string]: IAlertHandlerState };

export const getErrorMessageAtCreate = (keyValue: {
  [key: string]: string;
}): IAlertHandlerState => {
  const key = Object.keys(keyValue)[0];
  return errorsMessageAtCreate[key] || errorsMessageAtCreate['default'];
};
